import { createContext } from 'react'

const activeTabIndex = createContext()

export default activeTabIndex